import axiosInstance from 'app/modules/shared/api/axiosInstance';

export const RoutesAPI = {
    getSideMenuCategories: () => axiosInstance.get('dynamic_dashboards/get_side_menu_categories'),
};
